_         = require('underscore')
debounce  = require('debounce')
polygons  = require('./polygons')
Country   = require('./country')

module.exports = require('frontend/components/abstract').extend
  template: require('./index.pug')

  props:
    activeCountryCodes: { default: null }
    zoom:               { default: 2 }
    defaultCenter:      { default: null }
    interactive:        { default: null }

  data: ->
    countries:      []
    util:           null
    hoveredActive:  false
    mouseDown:      false
    dragging:       false
    dragCoord:      { x: 0, y: 0 }
    zoomStep:       parseInt(@zoom) || 2
    clicks:         0
    dblClickOffset: 500

    tmpTouchPos:    null

  computed:

    windowWidth: ->
      @.$store.state.window.width

    windowHeight: ->
      @.$store.state.window.height

    context: ->
      @.$refs.canvas.getContext('2d')

    isInteractive: ->
      @interactive != false && @interactive != 'false'

  methods:

    updateFull: ->
      @updateData()
      @reloadCountries()
      @renderCanvasContent()
      @updateCursor()

    updateDataAndRender: ->
      @updateData()
      @renderCanvasContent()

    updateData: ->
      @.$refs.canvas.width   = @.$refs.canvas.offsetWidth
      @.$refs.canvas.height  = @.$refs.canvas.offsetHeight
      @util.setContext(@context)
      @util.setCanvasSize(@.$refs.canvas.width, @.$refs.canvas.height)
      @util.setZoomStep(@zoomStep)

    updateCursor: ->
      if @dragging
        @.$el.style.cursor = 'move'
      else if @hoveredActive
        @.$el.style.cursor = 'pointer'
      else
        @.$el.style.cursor = 'default'

    renderCanvasContent: ->
      @drawBackground()
      @drawCountries()

    reloadCountries: ->
      @.$set @, 'countries', _.reduce(polygons['rows'], (memo, countryData) =>
        active = if _.contains(@activeCountryCodes, countryData[2]) then true else false

        memo.push new Country({
          util:         @util
          geometries:   countryData[1]['geometries'] || [countryData[1]['geometry']]
          iso_3166_2:   countryData[2]
          name:         countryData[0]
          active:       active
        }) unless _.contains(['AQ'], countryData[2])

        memo
      , [])

    drawBackground: ->
      @context.fillStyle = '#ffffff'
      @context.beginPath()
      @context.moveTo(0, @.$refs.canvas.height)
      @context.lineTo(@.$refs.canvas.width, @.$refs.canvas.height)
      @context.lineTo(@.$refs.canvas.width, 0)
      @context.lineTo(0, 0)
      @context.closePath()
      @context.fill()

    drawCountries: ->
      _.each @countries, (country) -> country.render()

    onMouseDown: (event) ->
      return unless @isInteractive

      @.$set @, 'mouseDown', true

    onTouchStart: (event) ->
      return unless @isInteractive

      @.$set @, 'tmpTouchPos', @getTouchPos(event)
      @.$set @, 'mouseDown', true if _.size(event.touches) == 1

    onMouseUp: (event) ->
      return unless @isInteractive

      @_handleMouseUpOrTouchEnd({ x: event.offsetX, y: event.offsetY })

    onTouchEnd: (event) ->
      return unless @isInteractive
      return unless _.isObject(@tmpTouchPos)

      @_handleMouseUpOrTouchEnd({ x: @tmpTouchPos.x, y: @tmpTouchPos.y })
      @.$set @, 'tmpTouchPos', null

    onMouseMove: (event) ->
      return unless @isInteractive
      @_handleMouseMoveOrTouchMove({ x: event.offsetX, y: event.offsetY })

    onTouchMove: (event) ->
      return unless @isInteractive
      return unless _.size(event.touches) == 1
      @_handleMouseMoveOrTouchMove({ x: event.touches[0].clientX, y: event.touches[0].clientY })

    onClick: (coords) ->
      return unless @isInteractive
      clickedLatLng   = @util.coordinatesToLatLng(coords)
      return unless clickedLatLng?

      clickedCountry  = _.reduce @countries, (memo, country) ->
        return memo if memo?
        if country.isLatLngInside(clickedLatLng) == true then country.iso_3166_2 else memo
      , null

      return unless clickedCountry?

      isActive = if _.contains(@activeCountryCodes, clickedCountry) then true else false
      @.$emit 'countryClick', { iso_3166_2: clickedCountry, active: isActive }

    onDoubleClick: (coords) ->
      return unless @isInteractive
      return if @dragging == true

      latLng = @util.coordinatesToLatLng(coords)
      return unless latLng?

      @util.setCenterLatLng(latLng)

      window.requestAnimationFrame => @_zoomIn()

    onClickZoomIn: ->
      return unless @isInteractive
      @_zoomIn()

    onClickZoomOut: ->
      return unless @isInteractive
      @_zoomOut()

    onMousewheel: (event) ->
      return unless @isInteractive
      if event.deltaY < 0
        @_debouncedZoomOut()
      else if event.deltaY > 0
        @_debouncedZoomIn()

    onMouseLeave: ->
      return unless @isInteractive

      if _.isObject(@tmpTouchPos)
        @_handleMouseUpOrTouchEnd({ x: @tmpTouchPos.x, y: @tmpTouchPos.y })
      else
        @_handleMouseUpOrTouchEnd(null)

      @.$set @, 'tmpTouchPos', null

    getTouchPos: (touchEvent) ->
      rect = @.$refs.canvas.getBoundingClientRect()

      return {
        x: touchEvent.touches[0].clientX - rect.left
        y: touchEvent.touches[0].clientY - rect.top
      }

    _zoomIn: ->
      @.$set @, 'zoomStep', @util.zoomIn()
      @updateFull()

    _debouncedZoomIn: debounce (-> @_zoomIn()), 50, true

    _zoomOut: ->
      @.$set @, 'zoomStep', @util.zoomOut()
      @updateFull()

    _debouncedZoomOut: debounce (-> @_zoomOut()), 50, true

    _handleMouseMoveOrTouchMove: (coords) ->
      return @_handleMoveNoDragging(coords) unless @mouseDown == true
      return @_handleDragging(coords) if @dragging == true

      @.$set @, 'dragging', true
      @.$set @, 'dragCoord', coords

    _handleMoveNoDragging: (newCoords) ->
      hoveredLatLng = @util.coordinatesToLatLng(newCoords)
      return unless hoveredLatLng?

      _.each @countries, (country) -> country.onMouseHoveredLatLng(hoveredLatLng)
      @.$set @, 'hoveredActive', _.some @countries, (country) -> country.isHovered()

    _handleDragging: (newCoords) ->
      return unless @dragging == true

      pOld = @util.coordinatesToLatLng(@dragCoord)
      pNew = @util.coordinatesToLatLng(newCoords)
      return unless pOld? && pNew?

      diff                = { lat: pOld.lat - pNew.lat, lng: pOld.lng - pNew.lng }
      topLeft             = @util.latLngToCoordinates({ lat: 85.0, lng: -180.0 })
      bottomRight         = @util.latLngToCoordinates({ lat: -85.0, lng: 180.0 })
      canvasBarrierX1     = @.$refs.canvas.width / 3
      canvasBarrierX2     = @.$refs.canvas.width - (@.$refs.canvas.width / 3)
      canvasBarrierY1     = @.$refs.canvas.height / 4
      canvasBarrierY2     = @.$refs.canvas.height - (@.$refs.canvas.height / 4)

      # movement check
      diff.lng = 0.0 if diff.lng < 0 && topLeft.x >= canvasBarrierX1
      diff.lng = 0.0 if diff.lng > 0 && bottomRight.x <= canvasBarrierX2
      diff.lat = 0.0 if diff.lat > 0 && topLeft.y >= canvasBarrierY1
      diff.lat = 0.0 if diff.lat < 0 && bottomRight.y <= canvasBarrierY2

      # move
      @util.changeCenterByLatLng(diff)

      @.$set @, 'dragCoord', { x: newCoords.x, y: newCoords.y }
      window.requestAnimationFrame => @renderCanvasContent()

    _handleMouseUpOrTouchEnd: (coords) ->
      @.$set @, 'mouseDown', false

      @_handleClickTrigger(coords) if @dragging != true && _.isObject(coords)

      @.$set @, 'dragging', false
      @.$set @, 'dragCoord', { x: 0, y: 0 }

    _handleClickTrigger: (coords) ->
      @.$set @, 'clicks', @clicks + 1

      if @clicks == 1
        @_dblClickTimer = window.setTimeout =>
          @.$set @, 'clicks', 0
          @onClick(coords)
        , @dblClickOffset
      else
        @.$set @, 'clicks', 0
        window.clearTimeout(@_dblClickTimer) if @_dblClickTimer?
        @onDoubleClick(coords)

  watch:

    windowWidth: ->
      @updateFull()

    windowHeight: ->
      @updateFull()

    hoveredActive: ->
      @updateCursor()

    dragging: ->
      @updateCursor()

    zoom: (newVal) ->
      @.$set @, 'zoomStep', parseInt(@zoom) || 2
      @updateDataAndRender()

  created: ->
    @.$set @, 'util', new (require('./util'))()

  mounted: ->
    @util.setCenterLatLng(@defaultCenter) if _.isObject(@defaultCenter)

    window.requestAnimationFrame => @updateFull()

  updated: ->
    window.requestAnimationFrame => @updateFull()



// WEBPACK FOOTER //
// ./assets/js/frontend/components/countries_map/components/map/index.coffee